import type { SVGProps } from 'react'
const SvgSyTicketAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M19 20.138V3.862a.5.5 0 0 0-.748-.435l-2.256 1.29a1 1 0 0 1-.992 0l-2.21-1.263a1.6 1.6 0 0 0-1.588 0l-2.21 1.262a1 1 0 0 1-.992 0L5.748 3.427A.5.5 0 0 0 5 3.862v16.276a.5.5 0 0 0 .748.434l2.256-1.288a1 1 0 0 1 .992 0l2.21 1.262a1.6 1.6 0 0 0 1.588 0l2.21-1.263a1 1 0 0 1 .992 0l2.256 1.29a.5.5 0 0 0 .748-.435"
		/>
		<path d="M10 8a1 1 0 0 0-1 1 1 1 0 0 0 1 1h4a1 1 0 0 0 1-1 1 1 0 0 0-1-1zm0 6a1 1 0 0 0-1 1 1 1 0 0 0 1 1h4a1 1 0 0 0 1-1 1 1 0 0 0-1-1zm0-3a1 1 0 0 0-1 1 1 1 0 0 0 1 1h4a1 1 0 0 0 1-1 1 1 0 0 0-1-1z" />
	</svg>
)
export default SvgSyTicketAlt
